app.service('productCardView', function (_, front, productCardConfig, log, modal, cookie, autocompleteInfo, loading, html, modalVideo, searchResultCollector, searchBox, productCardPhotos, productCardGallery, productTabs, productAvailability, productArchive, broker, outletNav, productTopSeeRecommended, account) {
	var $self, $expandDetails, $buttonStatic, $buttonFixed, $window, $clipboard, $sendOnDevice, $stars, $clipboardLink;
	var config, link;
	let computed = {
		bottomToCart: 0,
		bottomButtons: 0,
		windowHeight: 0
	};

	function setElements(){
		$self = $('#product-card');
		$expandDetails = $('#expand-details',$self);
		$clipboard = $('.js-clipboard', $self);
		$clipboardLink = $('.js-link-clipboard', $self);
		$stars = $('.js-stars', $self);
		$sendOnDevice = $('.js-send-on-device', $self);

		$buttonStatic = $('.js-main-add-to-cart', $self);
		$buttonFixed = $('#product-buttons-fixed', $self);
		$productButtons = $('.js-product-buttons', $self);
		$window = $(window);

	}
	function setEvents(){

		$('body').on('click', '.js-show-state-description', function() {
			const outletCategoryId = $(this).data('outlet-category');
			const modalId = `modal-state-${outletCategoryId}`;

			if (modal.isExist(modalId)) {
				return modal.open(modalId);
			}

			modal.generate({
				id: modalId,
				content: $(this).next()
			})
		});
		$('body').on('click', '.js-instalment-link', function(event) {
			productTabs.scrollToTab('raty', true);
			UA.pageInteraction('Raty', 'Klikniecie');
			event.preventDefault();
		});

		$expandDetails.on('click', function() {
			productTabs.open('opis', true);
			UA.pageInteraction('Detal', 'Szczegóły');
		});
		$clipboard.on('click', function() {
			UA.pageInteraction('Schowek', 'Do schowka - CTA');
			goToClipboard();
			log.event({
				id: 'add-to-clipboard',
				f03: config.plu,
				f04: front.page(),
				f05: account.user().frontUserLogged.toString(),
				f06: window.location.href
			 });
			log.recommendationsForAWS({
				productPlu: config.plu,
				eventCategory: 'Schowek',
				eventAction: 'Do schowka'
			});
		});
		$clipboardLink.on('click', function() {
			UA.pageInteraction('Schowek', 'Do schowka - Sekcja');
			goToClipboard();
		});
		$sendOnDevice.on('click', function() {
			UA.pageInteraction('Udostępnij i zapamiętaj', 'Sekcja');
		});
		$stars.on('click', function() {
			UA.pageInteraction('Opinie', 'Opis gwiazdki');
		});
		if(!cookie.isEmpty('compareBack')){
			link=cookie.get('compareBack');
			html.add('compare-mode');
			$('body').on("click", ".js-back-to-compare", function () {
				loading.redirect(link);
			});
			cookie.removeGlobal('compareBack');
		}else{
			html.remove('compare-mode');
		}
		if(!cookie.isEmpty('searchBack')){
			link=cookie.get('searchBack');
			html.add('search-mode');
			$('body').on("click", ".js-back-to-search", function () {
				loading.redirect(link);
			});
			cookie.removeGlobal('searchBack');
		}else{
			html.remove('search-mode');
		}
		if( $buttonFixed.length ){
			$window.resize(() => {
				computeValues();
				showFloatingButton();
			});

			_.onScroll(showFloatingButton)

			broker.on('ADD_TO_COMPARE_CLICK REMOVE_FROM_COMPARISON', () =>
				showFloatingButton()
			);
		}
		$('.product-photo a, .product-name a, .product-action a', '#successor-product').click(function(){
			UA.pageInteraction('Następnik', config.id);
		});
	}
	function goToClipboard(){
		loading.redirect('/customer-add-to-clipboard.ltr?productId='+config.id);
	}

	function computeValues() {
		computed.bottomToCart = $buttonStatic.offset().top + $buttonStatic.height() + 10;
		computed.bottomButtons = $productButtons.offset().top + $productButtons.height();
		computed.windowHeight = window.innerHeight ? window.innerHeight : $window.height();
	}

	function showFloatingButton(scroll = $window.scrollTop()) {
		if (scroll + computed.windowHeight < computed.bottomToCart) {
			$self.addClass('floating-button-above show-floating-button');
			$self.removeClass('floating-button-below');
		} else if (scroll > computed.bottomButtons) {
			$self.addClass('floating-button-below show-floating-button');
			$self.removeClass('floating-button-above');
		} else {
			$self.removeClass('show-floating-button');
		}
	}

	function init() {
		config = productCardConfig.getData();
		setElements();
		setEvents();
		modalVideo.init();
		if (window.location.hash === '#video') {
			productCardGallery.open(0, 'video');
		}

		if($("#product-archive").length){
			productArchive.init();
		}else{
			if (front.name() === "euro") {
				productAvailability.init();
			}
			searchResultCollector.init('product',config.title);
			productCardPhotos.init();
			productCardGallery.init();
			if( $buttonFixed.length ){
				computeValues();
				showFloatingButton();
			}
		}
		log.visit({
			productId : config.id,
			productCode : config.plu,
			productsGroupId : config.groupId,
			productAvailabilityStatusCode : config.productAvailabilityStatusCode,
			keyword: searchBox.getKeyword() || undefined,
			status: config.status
		});
		log.recommendationsForAWS({
			productPlu: config.plu,
			eventCategory: 'KP',
			eventAction: 'Wejście na widok'
		});
		if(isGoogleReferrer()){
			productTopSeeRecommended.init();
		}
		productTabs.init();
		if (!$('#product-archive').length) {
			outletNav.init();
		}
	}
	function isGoogleReferrer(){
		return front.isGoogleReferrer();
	}

	$(document).ready(function(){
		init();
	});

	return {
		init:init
	};
});
